import { ISetOwnerParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class SetWorkbooksOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setWorkbooksOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}
